import getConfigValue from './config';


export function getKratosUrl() {
  return getConfigValue('KRATOS_URL');
}
